<app-loader
	[enableCircle]="true"
	[isActive]="this.isLoading"
	[isAfterViewInit]="false"
></app-loader>
<h1 mat-dialog-title>
	<div class="flex flex-row items-center justify-start">
		<div>{{ 'tag.create' | translate }}</div>
		<div class="flex-auto"></div>
		<button
			mat-icon-button
			matDialogClose
			tabindex="-1"
		>
			<mat-icon>close</mat-icon>
		</button>
	</div>
</h1>
<mat-dialog-content cdkTrapFocus>
	<form
		[formGroup]="g"
		*ngIf="this.group as g"
		class="mb-4"
	>
		<div class="flex flex-col items-stretch justify-start gap-[25px]">
			<div class="flex flex-col gap-2 sm:flex-row sm:items-start">
				<mat-form-field
					appearance="fill"
					class="flex-auto"
				>
					<mat-label>Name</mat-label>
					<input
						cdkInitialFocus
						formControlName="name"
						matInput
						required
					>
					<mat-error *ngIf="this.formNameErrors as error">{{
						error.content | translate: error.args || {}
					}}</mat-error>
				</mat-form-field>
				<mat-form-field
					appearance="fill"
					class="project-color-field"
				>
					<mat-label>{{ 'tag.color' | translate }}</mat-label>
					<input
						autocomplete="off"
						formControlName="colorText"
						matInput
						maxlength="7"
						spellcheck="false"
					>
					<mat-error *ngIf="g.controls.colorText.touched && g.controls.colorText.errors?.invalidHex">
						{{ 'errors.invalidHex' | translate }}
					</mat-error>
					<div
						(colorPickerChange)="onColorPicked($event)"
						[colorPicker]="g.value.color"
						[cpAlphaChannel]="'disabled'"
						[cpCmykEnabled]="false"
						[cpOutputFormat]="'hex'"
						[cpPosition]="'bottom'"
						[cpPositionOffset]="'24px'"
						[matTooltip]="'tag.color' | translate"
						[style.backgroundColor]="g.value.color"
						class="project-color-dot project-color-dot--suffix color-picker-material"
						matSuffix
					></div>
				</mat-form-field>
			</div>
			<mat-form-field>
				<mat-label>{{ 'tag.type' | translate }}</mat-label>
				<mat-select formControlName="tagType">
					<mat-option [value]="0">{{ 'tag.project' | translate }}</mat-option>
					<mat-option [value]="1">{{ 'tag.time' | translate }}</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</form>
</mat-dialog-content>
<mat-dialog-actions
	*ngIf="workspace$createPermission | async; else createBlocked"
	class="mat-action-filled"
>
	<button
		(click)="this.createNewTag()"
		[disabled]="this.group.invalid"
		class="mat-action-filled"
		color="primary"
		mat-flat-button
	>
		{{ 'tag.create' | translate }}
	</button>
</mat-dialog-actions>
<ng-template #createBlocked>
	<mat-dialog-actions
		align="center"
		class="m-0"
	>
		<p
			class="text-warn m-0 text-center"
			translate
		>
			workspace.errors.admin-create-tag
		</p>
	</mat-dialog-actions>
</ng-template>
